import React from 'react';
// @ts-ignore
import MultiNoticeBar from 'pano-multi-notice-bar';
import { useStore } from 'effector-react';
import { $GateEditingSubTitle, $GateSubtitleList } from '@stores/editingStores';

export function SubtitlePreview() {
  const editing = useStore($GateEditingSubTitle.state);
  const list = useStore($GateSubtitleList.state);
  if (!editing && !list) return null;
  const data = editing ? [editing] : list;

  return (
    <div className="absolute top-0 left-0 right-0">
      <MultiNoticeBar disableClick baseSpeed={60} data={data} />
    </div>
  );
}
